import React, { useState } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import BetDetailContainer from './BetDetailContainer';
import styles from './assets/styles.scss';
import { assetIcons } from '../../config';
import { games } from '../../games/config';
import Anonymous from './assets/images/anonymous.svg?inline';

const cx = classNames.bind(styles);
export default function AllBetsHighRollersRow({
  result: {
    amount,
    area,
    asset,
    game,
    multiplier,
    nickname,
    payout,
    player_id: playerId,
    profile_image: profileImage,
    winner: isWin,
    game_result: result,
  },
  className,
}) {
  const gameName = game.replace(/^./, game[0].toUpperCase());
  const [isOpen, setIsOpen] = useState(false);
  const formattedMultiplier = `${Number(multiplier)?.toFixed(2)}x`;
  const formattedArea = games[game].formatPick(area);
  const formattedResult = games[game].formatResult(result);

  return (
    <tr className={cx('small', className)} onClick={() => setIsOpen(true)}>
      <td>
        {games[game].smallIcon({})}
        <span className={cx('small')}>{gameName}</span>
      </td>
      <td className={cx('user-image')}>
        {profileImage ? <img src={profileImage} alt="userImage" /> : <Anonymous />}
        <span className={cx('small')}>{nickname || 'hidden'}</span>
      </td>
      <td className={cx('hide-mobile', 'bet-amount')}>
        <span className={cx('small')}>{amount}</span>
        {assetIcons[asset]({})}
      </td>
      <td className={cx('hide-mobile')}>{isWin ? formattedMultiplier : '0.00x'}</td>
      <td className={cx('hide-mobile')}>{formattedArea}</td>
      <td className={cx('hide-mobile')}>{formattedResult}</td>
      <td className={cx(isWin ? 'win' : 'loss', 'bold')}>{isWin ? payout : -amount}</td>
      {isOpen ? (
        <BetDetailContainer
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          betAmount={amount}
          gameCode={game}
          multiplier={multiplier}
          playerId={playerId}
          isWin={isWin}
          asset={asset}
        />
      ) : null}
    </tr>
  );
}

AllBetsHighRollersRow.propTypes = {
  result: PropTypes.shape({
    game: PropTypes.string.isRequired,
    area: PropTypes.string.isRequired,
    nickname: PropTypes.string,
    profile_image: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    multiplier: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    payout: PropTypes.number.isRequired,
    player_id: PropTypes.number.isRequired,
    winner: PropTypes.bool,
    game_result: PropTypes.string.isRequired,
    asset: PropTypes.string.isRequired,
  }),
  className: PropTypes.string.isRequired,
};

AllBetsHighRollersRow.defaultProps = {
  result: {
    nickname: '',
  },
};
